(ns manage.adset-preview-panel.util.predicate
  (:require [common.util :as util]))

(defmulti -parse-value
  #(let [type (:macro-type %)]
     (if (coll? type)
       (last type)
       type)))

(defmethod -parse-value "integer" [{:keys [value]}]
  (let [parsed (js/parseInt value 10)]
    (if (js/isNaN parsed)
      value
      parsed)))

(defmethod -parse-value "timestamp" [{:keys [value]}]
  {:timestamp value})

(defmethod -parse-value "time" [{:keys [value]}]
  (if-let [match (re-matches #"^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$" (str value))]
    {:hour (js/parseInt (match 1) 10)
     :minute (js/parseInt (match 2) 10)}
    value))

(defmethod -parse-value :default [{:keys [value]}]
  value)

(defmulti -unparse-value
  #(let [type (:macro-type %)]
     (if (coll? type)
       (last type)
       type)))

(defmethod -unparse-value "integer" [{:keys [value]}]
  (str value))

(defmethod -unparse-value "timestamp" [{:keys [value]}]
  (:timestamp value))

(defmethod -unparse-value "time" [{:keys [value]}]
  (if (map? value)
    (util/format-string "%02d:%02d" (:hour value) (:minute value))
    value))

(defmethod -unparse-value :default [{:keys [value]}]
  value)

(defn parse-value
  [parsed-predicate value]
  (-parse-value (assoc parsed-predicate :value value)))

(defn unparse-value
  [parsed-predicate parsed-value]
  (-unparse-value (assoc parsed-predicate :value parsed-value)))
